var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.m_preloadSdk)?_c('div',{class:{ 'container-iframe': true, hide: !_vm.m_isIframeSdkVisible }},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},style:({
      backgroundColor: _vm.veridasConfigData.setup.success.backgroundColor
    }),attrs:{"id":"XpressID-iframe","src":_vm.valueIframe.urlXpressId,"sandbox":"allow-scripts allow-same-origin","allow":"camera; microphone; geolocation; gyroscope; accelerometer;","title":"Verificación de identidad"}}),_c('VeridasAnalytics')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }